import { createEnovaTheme } from './utils';

const DefaultTheme = createEnovaTheme();

export default DefaultTheme;
